import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import {
  ArrivalAirportFilterComponent,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/AirportFilter/ArrivalAirportFilterComponents'
import {
  GroupedArrivalAirportFilterComponent,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/AirportFilter/GroupedArrivalAirportFilterComponent'
import { isEmpty } from 'ramda'
import * as React from 'react'

export function ArrivalAirportFilter() {
  const { isFetching, options, setSelection, selectedValues } = useMultiSelectFilter('ArrivalAirport')
  const { sendEvent } = useAnalytics()

  const handleValueChange = React.useCallback((newSelectedValues: string[]) => {
    setSelection(newSelectedValues)
  }, [])

  const handleEditFinish = (selection: string[]) => {
    if (!isFetching) {
      if (selection.length) {
        sendEvent(
          createSearchFilterClickEvent({
            element: 'checkbox',
            type: 'arrival airports',
            result: selection.join(','),
          }),
        )
      }
    }
  }

  if (isEmpty(options)) {
    return null
  }

  const showGroups = options.filter(o => o.groupInfo).length > 0

  const FilterComponent = showGroups ? GroupedArrivalAirportFilterComponent : ArrivalAirportFilterComponent

  return (
    <FilterComponent
      onValueChange={handleValueChange}
      options={options}
      selectedValues={selectedValues}
      onEditFinish={handleEditFinish}
      disabled={isFetching}
    />
  )
}
